import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=94ab8348&scoped=true&lang=pug"
import script from "./AddressForm.vue?vue&type=script&lang=js"
export * from "./AddressForm.vue?vue&type=script&lang=js"
import style0 from "./AddressForm.vue?vue&type=style&index=0&id=94ab8348&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ab8348",
  null
  
)

export default component.exports